import { Injectable } from "@angular/core";
import { AppHttpClient } from "src/app/modules/shared/services/http-client.service";
import { AppUrlsService } from "src/app/modules/shared/services/app-urls.service";
@Injectable()
export class NavBarDataService {
  private domain = `${this.appUrlsService.CORE_LINK}`;

  private urls = {
    // alertUrl: `${this.domain}/api/v2/notifications/query`,
    projectUrl: `${this.domain}/api/v2/projects`,
  };

  constructor(
    private http: AppHttpClient,
    private appUrlsService: AppUrlsService
  ) {}
  // getAllAlertLevel(action, name, value) {
  //   let body = {
  //     query: [
  //       {
  //         action: "$" + action,
  //         name: name,
  //         value: value,
  //       },
  //     ],
  //   };
  //   return this.http.post(this.urls.alertUrl, body);
  // }
  getAllProject() {
    return this.http.get(this.urls.projectUrl);
  }
}
